export default "__VITE_ASSET__dqis5c7K__"